import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "komorotel_favorites";

/**
 * useFavorites — gère les favoris hôtels en localStorage
 * Retourne : { favorites, isFavorite, toggleFavorite, count }
 * favorites = tableau de hotelId (strings)
 */
export function useFavorites() {
  const [favorites, setFavorites] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  // Sync localStorage à chaque changement
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch {}
  }, [favorites]);

  const isFavorite = useCallback(
    (hotelId) => favorites.includes(String(hotelId)),
    [favorites]
  );

  const toggleFavorite = useCallback((hotelId) => {
    const id = String(hotelId);
    setFavorites(prev =>
      prev.includes(id) ? prev.filter(f => f !== id) : [...prev, id]
    );
  }, []);

  return { favorites, isFavorite, toggleFavorite, count: favorites.length };
}